import { EnumSelect } from '@core/components';
import { useAppDispatch } from '@core/redux/hooks';
import { MapboxStyle, mapboxStyles } from '@core/types';
import { FormControlLabel, Switch } from '@mui/material';
import { alkisToggleState, setAlkisEnabled } from '@projects/pages/detail/AlkisMap/layersState';
import { viewer3dActions, viewer3dSelectors } from '@viewer3D/redux';
import { useSelector } from 'react-redux';
import { useSnapshot } from 'valtio';
import { PublicLayerSelector } from './PublicLayerSelector';

export const MapStyleSelector = () => {
  const dispatch = useAppDispatch();
  const mapStyle = useSelector(viewer3dSelectors.mapStyle);
  const { enabled: alkisEnabled } = useSnapshot(alkisToggleState);

  return (
    <>
      <EnumSelect
        label="Map Style"
        value={mapStyle}
        onChange={(event) =>
          dispatch(viewer3dActions.setMapStyle(event.target.value as MapboxStyle))
        }
        options={mapboxStyles}
      />

      {mapStyle !== 'NONE' && (
        <FormControlLabel
          control={
            <Switch
              checked={alkisEnabled}
              onChange={(event) => setAlkisEnabled(event.target.checked)}
            />
          }
          label="Show Alkis Layer"
        />
      )}

      {alkisEnabled && <PublicLayerSelector />}
    </>
  );
};
